import {
  RemoteGetProfessionalsWorkJourney,
  RemoteHandleProfessionalsWorkJourney,
} from 'data/usecases';
import {
  GetProfessionalsWorkJourneyUseCaseInterface,
  HandleProfessionalsWorkJourneyUseCaseInterface,
} from 'domain/usecases';
import {
  makeApiUrlProfessionalsWorkJourney,
  makeApiUrlProfessionalsWorkJourneyExportExcel,
  makeApiUrlProfessionalsWorkJourneyExportPdf,
} from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetProfessionalsWorkJourney =
  (): GetProfessionalsWorkJourneyUseCaseInterface =>
    new RemoteGetProfessionalsWorkJourney(
      makeApiUrlProfessionalsWorkJourney(),
      makeAxiosHttpClient(),
    );

export const makeHandleProfessionalsWorkJourney =
  (): HandleProfessionalsWorkJourneyUseCaseInterface =>
    new RemoteHandleProfessionalsWorkJourney(
      makeApiUrlProfessionalsWorkJourneyExportPdf(),
      makeApiUrlProfessionalsWorkJourneyExportExcel(),
      makeAxiosHttpClient(),
    );
